import React, { Component } from 'react';
import { Layout } from 'antd';

export default class Header extends Component {

    render() {
        return (
            <Layout.Header className={"layout-header-primary layout-h center " + this.props.className || ""}>
                {this.props.children}
            </Layout.Header>
        );
    }
}